export const KEY_PHRASES_OPERATION_NAME = 'PlatformHighlightKeywordsQuery';
export const KeyPhrasesQuery: "\n\tquery PlatformHighlightKeywordsQuery(\n\t\t$entityAri: String!\n\t\t$workspaceId: String!\n\t\t$jiraReporterAccountId: String\n\t\t$jiraAssigneeAccountId: String\n\t\t$inputText: KnowledgeDiscoveryKeyPhraseInputText\n\t) {\n\t\tknowledgeDiscovery  {\n\t\t\tkeyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) \n\t\t\t\t@optIn(to: \"KnowledgeDiscovery Get Key Phrases\") {\n\t\t\t\t__typename\n\t\t\t\t... on KnowledgeDiscoveryKeyPhraseConnection {\n\t\t\t\t\tnodes {\n\t\t\t\t\t\t... on KnowledgeDiscoveryKeyPhrase {\n\t\t\t\t\t\t\tkeyPhrase\n\t\t\t\t\t\t\tcategory\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t... on QueryError {\n\t\t\t\t\tmessage\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n" = `
	query ${KEY_PHRASES_OPERATION_NAME}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
